// Module
var code = `<button class="dropdown_button">#TITLE</button>`;
// Exports
export default code;